export class UserException {
    userIds: string[] = [];
    startDate: string = '';
    endDate: string = '';
}